import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function RightsSection({ data, registerSection }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) registerSection("rights", ref.current);
  }, [registerSection]);

  if (!data) return null;

  return (
    <section
      ref={ref}
      id="rights"
      className="py-16 md:py-24 bg-card/50"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Left: Section info */}
          <motion.div
            className="lg:col-span-4"
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.5 }}
          >
            <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-muted-foreground mb-3">
              Know Your Rights
            </p>
            <h2 className="font-heading text-2xl md:text-3xl tracking-[-0.01em] text-foreground">
              {data.section_title}
            </h2>
            <p className="mt-4 text-sm md:text-base text-muted-foreground leading-relaxed">
              {data.section_subtitle}
            </p>
            {data.last_updated && (
              <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.14em] text-muted-foreground/60">
                Last updated: {data.last_updated}
              </p>
            )}
          </motion.div>

          {/* Right: Accordion */}
          <motion.div
            className="lg:col-span-8"
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <Accordion
              type="single"
              collapsible
              className="w-full"
              data-testid="rights-accordion"
            >
              {data.items?.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-border"
                >
                  <AccordionTrigger
                    className="text-left text-sm md:text-base font-semibold text-foreground hover:no-underline py-5"
                    data-testid="rights-accordion-item-trigger"
                  >
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-muted-foreground leading-relaxed max-w-prose pb-5">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
